 <template>
   <div>
  
   </div>
 </template>
 <script>
// import { mapMutations } from 'vuex'
// import Count from '../components/shop/Count.vue'
// import Menu from '../components/common/Menu.vue'
export default {
  name: 'login',
  data() {
    return {
       form: {
          name: '',
          tel: '',
          seat: '',
          check: false,
          msg: ''
        },
     appid:this.GLOBAL.appid,
     secret:this.GLOBAL.secret,
     headimgurl:'',
      show: true,
      count: '',
      ccode: '',
      open:'',
      timer: null,
      check: '',
       num: '',
       openid:'',
       nickname:'',
       accessToken:'',
      option: {
        label: 'Option Checkbox',
        value: 'optionValue',
        disabled: false
      }
    }
  },
  //created   mounted
   mounted() {
    this.onload();
  },
  methods: {
    getUrlKey(name){//获取url 参数
   return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
  },
  onload() {
  let code=this.getUrlKey('code');
   console.log("++++++++++"+code); 
    let appId=this.appid;
    let appsecret=this.secret;
      let urlPath ='/hqxx/sns/oauth2/access_token?appid='+appId +'&secret='+appsecret +'&code='+code +'&grant_type=authorization_code';
		   if(code){
		       //调用接口获取openId   参考文档https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842
       this.$axios.get(urlPath) //这个urlPath就是上一步拼接的请求地址
      .then((res) => {
          console.log(res.data.openid); //如果请求成功，你就可以看到openId了，否则会返回错误代码和错误原因
           this.openid=res.data.openid
           this.accessToken=res.data.access_token
           // https://api.weixin.qq.com/sns/userinfo?access_token="+accessToken+"&openid="+openId+"&lang=zh_CN
 let urlyhPath ='/hqxx/sns/userinfo?access_token='+this.accessToken+'&openid='+this.openid+'&lang=zh_CN';
  this.$axios.get(urlyhPath) 
      .then((res) => {
         this.nickname=res.data.nickname;
          })
        })
        .catch(function(err) {
          console.log(err);
        });
            
				   }else{
				   	     this.getCodeApi("132");
           }
},
 getUrlKey:function(name){//获取url 参数
   return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
  },
   getCodeApi(state){//获取code   
     let urlNow='http://192.168.43.18:8080/authorization'
     //encodeURIComponent(window.location.href);
     let scope='snsapi_base';    //snsapi_userinfo   //静默授权 snsapi_base 用户无感知
    let appid=this.appid;
     let url=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
     window.location.replace(url);
},
    getCode() {
         var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/ // 验证是不是以13,15,18,17开头的数字
      var num = /^\d{6}$/ // 验证是否6位数字
      if (this.form.tel === '') {
         this.$notify.error({
          message: '手机号不能为空！'
        });
      } else if (this.form.tel.length !== 11) {
         this.$notify.error({
          message: '请输入11位的手机号码！'
        });
      } else if (!myreg.test(this.form.tel)) {
         this.$notify.error({
          message: '请输入有效的手机号码！'
        });
      }else{
      const TIME_COUNT = 30
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
         this.$axios
        .post('/api/user/gettelcode',{
          mobilePhone:this.form.tel
          },{
          emulateJSON: true
          })
        .then(res => {
          if (res.data.vld === '0') {
              this.$message({
                 showClose: true,
                 message: '手机号码验证成功，请注意查收短信！',
                  type: 'success'
             });
              this.ccode = res.data.code
               this.open = res.data.open
            
              return "error";
          } else if(res.data.vld === '4') {
            this.$notify.error({
                 message: '验证码发送失败，请稍后重试！'
             });
              return "error";
          }else if(res.data.vld === '5') {
            this.$notify.error({
                 message: '您操作的过于频繁，请稍后重试！'
             });
              return "error";
          }else {
            
          }
        })
      }
        }
    },
    submit() {
      var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/ // 验证是不是以13,15,18,17开头的数字
      var num = /^\d{6}$/ // 验证是否6位数字
      if (this.form.tel === '') {
        this.$notify.error({
                 message: '手机号不能为空！'
             });
               return "error";
      } else if (this.form.tel.length !== 11) {
         this.$notify.error({
                 message: '请输入11位的手机号码！！'
             });
               return "error";
      } else if (!myreg.test(this.form.tel)) {
         this.$notify.error({
                 message: '请输入有效的手机号码！'
             });
               return "error";
      } else if (this.form.msg === '') {
         this.$notify.error({
                 message: '请填写验证码！'
             });
               return "error";
      } else if(this.ccode!==this.form.msg || this.open!==this.form.tel){
              this.$notify.error({
                 message: '请填写正确的验证码！'
             });
               return "error";
      } else{
        this.$axios.post('/api/user/yhbd',{
          mobilePhone:this.form.tel,
          msg:this.form.msg
          },{
          emulateJSON: true
          })
        .then(res => {
          if (res.data.sjhyn === '0') {
               this.$notify.error({
                 showClose: true,
                 message: '手机号码不存在！',
                  type: 'success'
             });
              return "error";
          }else {
            //进行绑定用户
           this.$axios.post('/api/user/binding',{
          mobilePhone:this.form.tel,
          msg:this.form.msg,
          nickname:this.nickname,
          openid:this.openid
          },{
          emulateJSON: true
          })
        .then(res => {
          if (res.data.sjhyn === '0') {
               this.$notify.error({
                 showClose: true,
                 message: '用户绑定成功',
                  type: 'success'
             });
              return "error";
          }else {
            this.$notify.error({
                 showClose: true,
                 message: '用户绑定失败',
                  type: 'success'
             });
              return "error";
          }
        })
        .catch(function(err) {
          console.log(err);
        });
          }
        })
      }
    }
  }
  // components: { Count, Menu }

}
</script>

<style scoped>
* {

  padding: 0;
}
input {
  flex: 1;
}
a {
  cursor: pointer;
}
.phone {
  width: 220px;
  display: block;
  margin: 0 auto;
  font-size: 16px;
  /* color: #666;     */
  outline: none;
  padding-top: 30px;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom: 0.1px solid rgb(196, 194, 194);
  position: relative;
}

.close_tel {
  font-size: 12px;
  width: 100px;
  height: 23px;
  line-height: 25px;
  border-radius: 5px;
  background-color: rgb(86, 159, 255);
  color: white;
  right: 20%;
  top: 255px;
  outline: none;
  border: 0;
  font-weight: 400;
  cursor: pointer;
}
.close_tel2 {
  width: 100px;
  height: 23px;
  line-height: 25px;
  border-radius: 5px;
  background-color: rgb(211, 211, 211);
  color: white;
  right: 20%;
  top: 255px;
  outline: none;
  border: 0;
  font-weight: 400;
  cursor: pointer;
}
.login {
  padding-top: 50px;
  background-color: white;
  font-size: 16px;
}
.logo {
  width: 220px;
  /* border: #666 1px solid; */
  margin: 0 auto;
}
.logo img {
  display: block;
  width: 100%;
  height: auto;
}
.login p {
  font-size: 13px;
  width: 260px;
  text-align: center;
  margin: 0 auto;
}
.welcome {
  color: #338bff;
}
.check-item {
  width: 220px;
  margin: 10px auto;
  font-size: 12px;
  color: grey;
}
.info {
  color: grey;
  letter-spacing: 1.2px;
}
.phone {
  width: 220px;
  display: block;
  margin: 0 auto;
  font-size: 16px;
  /* color: #999;     */
  outline: none;
  padding-top: 30px;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom: 0.1px solid rgb(196, 194, 194);
}

input {
  padding-bottom: 10px;
  font-weight: 700;
  color: #666;
  letter-spacing: 2px;
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #999;
}

.subLogin {
  /* display: block; */

  width: 240px;

  background-color: #338bff;
  color: white;
  border-radius: 10px;
  font-size:17px;
  outline: none;
  /* border: 0;  */
  cursor: pointer;
  letter-spacing: 10px;
}
.online {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  letter-spacing: 15px;
  color: rgb(180, 173, 173);
  position: fixed;
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue